import React from 'react'
import PropTypes from 'prop-types'
import { boolAttr } from '@fs/zion-frontend-friends'
import { css } from '@linaria/core'

const separatorCss = css`
  height: var(--separator-size);

  // We want to use Separator inside of ResponsiveTable but
  // raw text nodes don't count against the sibling selector
  // (because they are not elements) so this rule causes all but
  // the first Separator to disappear. (FRONTIER-1107)
  *:not(td) > & + &,
  &[separation='hide'] {
    display: none;
  }

  &[grow-y] {
    flex-grow: 1;
  }
`

export default function Separator({ size = 'sm', growY = false }) {
  return (
    <div
      separation={size}
      className={separatorCss}
      style={{ '--separator-size': `var(--spacer-${size})` }}
      grow-y={boolAttr(growY)}
      aria-hidden
    />
  )
}

Separator.propTypes = {
  /** The size of the spacing. NOTE: Size xl and xxl are for Billboard use only. */
  size: PropTypes.oneOf(['xxl', 'xl', 'lg', 'md', 'sm', 'xs', 'xxs', 'nano', 'hide']),

  /**
   * Whether you want this separator to fill any available vertical space.
   *
   * NOTE: This only works when the Separator is a direct child of a flex container,
   * like LayoutBand or Card.
   */
  growY: PropTypes.bool,
}
